import React from 'react';

const Subscription = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="bg-white rounded-lg shadow-md p-8 text-center">
        <div className="mb-6">
          <svg
            className="mx-auto h-16 w-16 text-indigo-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
            />
          </svg>
        </div>

        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Subscription
        </h1>

        <div className="max-w-2xl mx-auto">
          <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-6 mb-6">
            <h2 className="text-2xl font-semibold text-indigo-900 mb-3">
              Currently Free!
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              VibeyFocus is completely free while we're still hammering out bugs
              and improving the user experience. Enjoy full access to all features
              as we continue to refine the app!
            </p>
          </div>

          <div className="text-left space-y-4 text-gray-600">
            <p>
              <strong className="text-gray-900">What you get right now:</strong>
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Unlimited focus sessions</li>
              <li>All session customization features</li>
            </ul>

            <p className="mt-6 text-sm text-gray-500">
              We'll announce any future changes to our pricing model well in advance.
              Thank you for being an early supporter!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
